import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const AnswerYesNoQuestion = ({
  letter,
  text,
  isSelected,
  onClick,
  hasOtherOption,
  isOtherOption,
  onOtherTextChange,
  onOtherErrorChange,
  otherText,
}) => {
  const { t } = useTranslation();
  const [localOtherText, setLocalOtherText] = useState(otherText || "");
  const [error, setError] = useState("");

  useEffect(() => {
    setLocalOtherText(otherText || "");
  }, [otherText]);

  useEffect(() => {
    if (isSelected && isOtherOption && hasOtherOption) {
      if (!localOtherText.trim()) {
        setError(t("base.pleaseSpecifyOther"));
        onOtherErrorChange?.(true);
      } else {
        setError("");
        onOtherErrorChange?.(false);
      }
    } else {
      setError("");
      onOtherErrorChange?.(false);
    }
  }, [
    isSelected,
    isOtherOption,
    hasOtherOption,
    localOtherText,
    onOtherErrorChange,
    t,
  ]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setLocalOtherText(value);
    onOtherTextChange?.(value);
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className={`flex gap-[18px] w-full items-center bg-white rounded-xl min-h-[60px] cursor-pointer transition-all duration-200 `}
      onClick={onClick}
    >
      <div className="flex items-center px-6 py-4 w-full">
        <div className="flex items-center gap-3 w-full">
          <div className="flex-shrink-0 flex items-center justify-center">
            {/* <input
              type="radio"
              checked={isSelected}
              onChange={() => {}} // Dummy onChange để tránh warning, logic chính ở onClick của div cha
              className="w-5 h-5 text-[#253FF6] border-gray-300 focus:ring-[#253FF6]/30 "
            
            /> */}
            <input
              type="radio"
              checked={isSelected}
              onChange={() => {}}
              className={`
            relative appearance-none w-5 h-5 rounded-full border-2
            ${isSelected ? "border-[#253FF6]" : "border-gray-400"}
            before:content-[''] before:absolute before:top-[3px] before:left-[3px]
            before:w-[10px] before:h-[10px] before:rounded-full 
            before:border-2 before:border-[#253FF6]
            ${isSelected ? "" : "before:hidden"}
            after:content-[''] after:absolute after:-top-1 after:-left-1
            after:w-[24px] after:h-[24px] after:rounded-full 
            after:border-1 after:border-[#253FF6]
            ${isSelected ? "" : "after:hidden"}
         `}
            />
          </div>
          <div className="flex flex-col flex-grow ml-1">
            {isSelected && hasOtherOption && isOtherOption ? (
              <>
                <input
                  type="text"
                  value={localOtherText}
                  onChange={handleInputChange}
                  onClick={handleInputClick}
                  className="text-[#253FF6] rounded-md w-full focus:outline-none focus:border-none focus:ring-0 focus:ring-[#253FF6]/30 text-xl font-medium"
                  placeholder={t("base.othersPleaseSpecify")}
                />
                {error && (
                  <span className="text-[#EF4056] text-sm mt-1">{error}</span>
                )}
              </>
            ) : (
              <span
                className={`text-xl ${
                  isSelected
                    ? "text-[#253FF6] font-bold"
                    : "font-medium text-[#A0A0A0]"
                }`}
              >
                {text}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnswerYesNoQuestion;
